import { ParentInfoBox } from './StorySBKurzerklaert';

interface Props {
  parentBox: string | null;
  citations: unknown;
}

/**
 * SB "Sachgeschichte" narrative variant — renders only the Eltern-Info
 * + Quellen box below the story text. No Wow-Fakt / Probier-mal.
 *
 * ParentInfoBox is shared with StorySBKurzerklaert for visual + markup
 * parity. If the story has no parentBox, nothing renders here.
 */
export function StorySBSachgeschichte({ parentBox, citations }: Props) {
  return <ParentInfoBox parentBox={parentBox} citations={citations} />;
}
